export const colorTokens = Object.freeze({
  ink: "#00132F",
  inkSoft: "rgba(0, 19, 47, 0.72)",
  paper: "#FFFFFF",
  surface: "#FFFFFF",
  divider: "rgba(0, 19, 47, 0.16)",
  coral: "#E03C7D",
  sun: "#EFB94D",
  sky: "#6E8CFF",
  success: "#6E8CFF",
  error: "#E03C7D",
} as const);

export const typographyTokens = Object.freeze({
  displayLg: {
    fontFamily: "Mali",
    fontSize: 48,
    fontWeight: 700,
    lineHeight: 52,
    letterSpacing: 0,
  },
  displayMd: {
    fontFamily: "Mali",
    fontSize: 36,
    fontWeight: 700,
    lineHeight: 40,
    letterSpacing: 0,
  },
  displayMobile: {
    fontFamily: "Mali",
    fontSize: 32,
    fontWeight: 700,
    lineHeight: 36,
    letterSpacing: 0,
  },
  headingLg: {
    fontFamily: "Manrope",
    fontSize: 24,
    fontWeight: 700,
    lineHeight: 32,
    letterSpacing: 0,
  },
  headingMd: {
    fontFamily: "Manrope",
    fontSize: 20,
    fontWeight: 600,
    lineHeight: 28,
    letterSpacing: 0,
  },
  bodyLg: {
    fontFamily: "Manrope",
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 24,
    letterSpacing: 0,
  },
  bodyMd: {
    fontFamily: "Manrope",
    fontSize: 14,
    fontWeight: 400,
    lineHeight: 20,
    letterSpacing: 0,
  },
  labelLg: {
    fontFamily: "Manrope",
    fontSize: 14,
    fontWeight: 600,
    lineHeight: 20,
    letterSpacing: 0,
  },
  labelSm: {
    fontFamily: "Manrope",
    fontSize: 12,
    fontWeight: 600,
    lineHeight: 16,
    letterSpacing: 0,
  },
} as const);

export const spacingTokens = Object.freeze({
  base: 4,
  2: 8,
  3: 12,
  4: 16,
  6: 24,
  8: 32,
} as const);

export const layoutTokens = Object.freeze({
  mobileMargin: 16,
  desktopMargin: 24,
  gutter: 12,
  desktopShareRailMin: 248,
  desktopShareRailMax: 272,
  mobileBreakpoint: 720,
  desktopBreakpoint: 1024,
} as const);

export const radiusTokens = Object.freeze({
  sm: 4,
  md: 6,
  lg: 8,
} as const);

export const borderTokens = Object.freeze({
  default: 1,
} as const);

export const dimensionTokens = Object.freeze({
  touchTarget: 44,
  primaryControlHeight: 48,
  compactIcon: 20,
  standardIcon: 24,
  progressBarHeight: 4,
} as const);

export const uiTokens = Object.freeze({
  color: colorTokens,
  type: typographyTokens,
  space: spacingTokens,
  layout: layoutTokens,
  radius: radiusTokens,
  border: borderTokens,
  dimension: dimensionTokens,
} as const);

export type UiTokens = typeof uiTokens;
